/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Container, Grid } from 'theme-ui';
import SectionHeader from '../components/section-header';
import FeatureCardColumn from 'components/feature-card-column.js';
import Performance from 'assets/key-feature/performance.svg';
import Partnership from 'assets/key-feature/partnership.svg';
import Subscription from 'assets/key-feature/subscription.svg';
import Support from 'assets/key-feature/support.svg';

const data = [
  {
    id: 1,
    imgSrc: Performance,
    altText: 'التنظيف والتطهير',
    title: 'التنظيف والتطهير',
    text:
      'تلميع الأرضيات والحوائط.. والنجف والستائر تعيد تلميع جميع المفروشات تنظيف وتطهير المطبخ من جميع الدهون والأوساخ',
  },
  {
    id: 2,
    imgSrc: Partnership,
    altText: 'مكافحة الحشرات',
    title: 'مكافحة الحشرات',
    text:
      'مكافحة الحشرات والقوارض',
  },
  {
    id: 3,
    imgSrc: Subscription,
    altText: 'نقل الاثاث',
    title: 'نقل الاثاث',
    text:
      'نقل الاثاث',
  },
  {
    id: 4,
    imgSrc: Support,
    altText: 'التعقيم',
    title: 'التعقيم',
    text:
      'تعقيم الأثاث والمفروشات',
  },
];

export default function KeyFeature() {
  return (
    <section sx={{ variant: 'section.keyFeature' }} id="services">
      <Container>
        <SectionHeader
          slogan="لأنكم الافضل.. تحتاجون الأفضل في مجال التنظيف والتطهير"
          title="خدماتنا"
        />

        <Grid sx={styles.grid}>
          {data.map((item) => (
            <FeatureCardColumn
              key={item.id}
              src={item.imgSrc}
              alt={item.altText}
              title={item.title}
              text={item.text}
            />
          ))}
        </Grid>
      </Container>
    </section>
  );
}

const styles = {
  grid: {
    width: ['100%', '80%', '100%'],
    mx: 'auto',
    gridGap: [
      '35px 0',
      null,
      '40px 40px',
      '50px 60px',
      '30px',
      '50px 40px',
      '55px 90px',
    ],
    gridTemplateColumns: [
      'repeat(1,1fr)',
      null,
      'repeat(2,1fr)',
      null,
      'repeat(4,1fr)',
    ],
  },
};
